const onLoadPropertiesMixin = {
	data: function () {
		return {
			defaultValues: [],
			maxProperties: {
				width: 0,
				height: 0,
				diameter: 0,
				length: 0,
			},
		};
	},
	methods: {
		/**
		 * Loads a default value if specified in the backend
		 * @param {object} model the data model to update/check
		 */
		setDefaultValues: function (model) {
			const vm = this;
			Object.keys(vm.$refs).forEach((ref) => {
				const element = vm.$refs[ref];
				const defaultValue = element.dataset.defaultValue;
				if (defaultValue !== undefined) {
					vm.$set(model, element.id, defaultValue);
				}
			});
		},
		/**
		 * Sets the max and minimum properties of the form field.These values come from the defaultValues object
		 * @param {string} field property to set e.g.max / min.
		 * @param {string} property field to set property on.
		 */
		setMaxMinProperties: function (value = '0') {
			const vm = this;

			if (vm.isNullOrEmpty(vm.maxMinRules)) {
				return;
			}

			let result = undefined;
			vm.maxMinRules.forEach((obj) => {
				if (obj.thickness.value === value) {
					result = obj;
				}
			});

			// let result = vm.maxMinRules.filter((obj) => obj.thickness.value === value)[0];

			if (value == '0' && result == undefined) {
				return;
			}

			if (result == undefined) {
				vm.setMaxMinProperties();
			}

			if (result) {
				let properties = result.thickness.properties;

				for (var prop in properties) {
					var el = document.getElementById(prop);
					if (el == undefined) {
						continue;
					}
					for (var nestedProp in properties[prop]) {
						el.dataset[nestedProp] = properties[prop][nestedProp];
						if (nestedProp == 'max') {
							this.$set(this.maxProperties, prop, properties[prop][nestedProp]);
						}
						// console.log(prop + '-  ' + nestedProp + ': ' + properties[prop][nestedProp]);
					}
				}
			}

			return null;
		},
		setMinValue: function (field) {
			const vm = this;
			return vm.setMaxMinProperties(field, 'min');
		},
		setMaxValue: function (field) {
			const vm = this;
			return vm.setMaxMinProperties(field, 'max');
		},
	},
	watch: {
		'maxProperties.maxheight': function (value) {
			const vm = this;
			vm.checkMinMax('height', null, 'max', value);
		},
		'maxProperties.maxwidth': function (value) {
			const vm = this;
			vm.checkMinMax('width', null, 'max', value);
		},
		'maxProperties.maxdiameter': function (value) {
			const vm = this;
			vm.checkMinMax('diameter', null, 'max', value);
		},
		'maxProperties.maxlength': function (value) {
			const vm = this;
			vm.checkMinMax('length', null, 'max', value);
		},
	},
};
